//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-right-doodle.svg';

const GlobalTitle = () => import(
/* webpackChunkName:"global-editorial" */
'~/components/atoms/Editorial/Global/GlobalTitle.vue');

export default {
  name: 'ChristmasSelection',
  components: {
    GlobalTitle
  },
  props: {
    url: {
      type: String,
      required: true
    },
    backgroundColor: {
      type: String,
      default: ''
    },
    src: {
      type: String,
      default: ''
    },
    textColor: {
      type: String,
      required: true
    },
    title: {
      type: Object,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  }
};